import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from 'react';
import AdminLayout from 'Components/Admin/AdminLayout';
import { Container, Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Alert, Card, CardBody } from 'reactstrap';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faTrash, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
const API_BASE = window.HMI_API_BASE || process.env.REACT_APP_API_URL || 'https://api.heresmyinfo.com/api';
export default function PlansFeatures() {
  const {
    t
  } = useTranslation();
  const [activeTab, setActiveTab] = useState('plans');
  const [plans, setPlans] = useState([]);
  const [addons, setAddons] = useState([]);
  const [features, setFeatures] = useState([]);
  const [assignments, setAssignments] = useState({
    planFeatures: [],
    addonFeatures: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null); // Modals state

  const [planModal, setPlanModal] = useState(false);
  const [addonModal, setAddonModal] = useState(false);
  const [featureModal, setFeatureModal] = useState(false); // Form states

  const [planForm, setPlanForm] = useState({
    id: '',
    name: '',
    type: 'Individual',
    monthly_price: 0,
    yearly_price: 0,
    description: '',
    cta_label: 'Get Started',
    highlight_badge: '',
    active: true,
    display_order: 0,
    billing_price_id: ''
  });
  const [addonForm, setAddonForm] = useState({
    id: '',
    name: '',
    description: '',
    monthly_price: 0,
    price_type: 'flat',
    active: true,
    display_order: 0,
    billing_price_id: ''
  });
  const [featureForm, setFeatureForm] = useState({
    id: '',
    name: '',
    description: '',
    category: 'Branding',
    active: true,
    display_order: 0
  });
  const token = localStorage.getItem('token') || '';

  const fetchData = async () => {
    setLoading(true);

    try {
      const headers = {
        'Authorization': `Bearer ${token}`
      };
      const plansRes = await fetch(`${API_BASE}/admin/plans`, {
        headers
      }).then(r => r.json());
      const addonsRes = await fetch(`${API_BASE}/admin/addons`, {
        headers
      }).then(r => r.json());
      const featuresRes = await fetch(`${API_BASE}/admin/features`, {
        headers
      }).then(r => r.json());
      const assignmentsRes = await fetch(`${API_BASE}/admin/features/assignments`, {
        headers
      }).then(r => r.json());
      if (plansRes.success) setPlans(plansRes.data);
      if (addonsRes.success) setAddons(addonsRes.data);
      if (featuresRes.success) setFeatures(featuresRes.data);
      if (assignmentsRes.success) setAssignments(assignmentsRes.data);
    } catch (err) {
      console.error(err);
      setError('Failed to fetch configuration data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const showToast = (msg, isSuccess = true) => {
    if (isSuccess) {
      setSuccess(msg);
      setTimeout(() => setSuccess(null), 3000);
    } else {
      setError(msg);
      setTimeout(() => setError(null), 4000);
    }
  }; // Plan CRUD Actions


  const handleSavePlan = async e => {
    e.preventDefault();
    const isEdit = !!planForm.id;
    const url = isEdit ? `${API_BASE}/admin/plans/${planForm.id}` : `${API_BASE}/admin/plans`;
    const method = isEdit ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(planForm)
      }).then(r => r.json());

      if (res.success) {
        showToast(`Plan successfully ${isEdit ? 'updated' : 'created'}`);
        setPlanModal(false);
        fetchData();
      } else {
        showToast(res.error?.message || 'Error saving plan', false);
      }
    } catch (err) {
      showToast('Connection error saving plan', false);
    }
  };

  const handleDeletePlan = async id => {
    if (!window.confirm('Are you sure you want to delete this subscription plan?')) return;

    try {
      const res = await fetch(`${API_BASE}/admin/plans/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).then(r => r.json());

      if (res.success) {
        showToast('Plan deleted successfully');
        fetchData();
      } else {
        showToast(res.error?.message || 'Error deleting plan', false);
      }
    } catch (err) {
      showToast('Connection error deleting plan', false);
    }
  }; // Addon CRUD Actions


  const handleSaveAddon = async e => {
    e.preventDefault();
    const isEdit = !!addonForm.id;
    const url = isEdit ? `${API_BASE}/admin/addons/${addonForm.id}` : `${API_BASE}/admin/addons`;
    const method = isEdit ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(addonForm)
      }).then(r => r.json());

      if (res.success) {
        showToast(`Add-on successfully ${isEdit ? 'updated' : 'created'}`);
        setAddonModal(false);
        fetchData();
      } else {
        showToast(res.error?.message || 'Error saving add-on', false);
      }
    } catch (err) {
      showToast('Connection error saving add-on', false);
    }
  };

  const handleDeleteAddon = async id => {
    if (!window.confirm('Are you sure you want to delete this add-on service?')) return;

    try {
      const res = await fetch(`${API_BASE}/admin/addons/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).then(r => r.json());

      if (res.success) {
        showToast('Add-on deleted successfully');
        fetchData();
      } else {
        showToast(res.error?.message || 'Error deleting add-on', false);
      }
    } catch (err) {
      showToast('Connection error deleting add-on', false);
    }
  }; // Feature CRUD Actions


  const handleSaveFeature = async e => {
    e.preventDefault();
    const isEdit = !!featureForm.id;
    const url = isEdit ? `${API_BASE}/admin/features/${featureForm.id}` : `${API_BASE}/admin/features`;
    const method = isEdit ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(featureForm)
      }).then(r => r.json());

      if (res.success) {
        showToast(`Feature successfully ${isEdit ? 'updated' : 'created'}`);
        setFeatureModal(false);
        fetchData();
      } else {
        showToast(res.error?.message || 'Error saving feature', false);
      }
    } catch (err) {
      showToast('Connection error saving feature', false);
    }
  };

  const handleDeleteFeature = async id => {
    if (!window.confirm('Are you sure you want to delete this feature?')) return;

    try {
      const res = await fetch(`${API_BASE}/admin/features/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).then(r => r.json());

      if (res.success) {
        showToast('Feature deleted successfully');
        fetchData();
      } else {
        showToast(res.error?.message || 'Error deleting feature', false);
      }
    } catch (err) {
      showToast('Connection error deleting feature', false);
    }
  }; // Feature mapping toggle


  const isFeatureMappedToPlan = (planId, featureId) => {
    return assignments.planFeatures.some(pf => pf.plan_id === planId && pf.feature_id === featureId);
  };

  const isFeatureMappedToAddon = (addonId, featureId) => {
    return assignments.addonFeatures.some(af => af.addon_id === addonId && af.feature_id === featureId);
  };

  const handleTogglePlanFeature = (planId, featureId) => {
    setAssignments(prev => {
      const mapped = prev.planFeatures.some(pf => pf.plan_id === planId && pf.feature_id === featureId);
      let updatedPlanFeatures;

      if (mapped) {
        updatedPlanFeatures = prev.planFeatures.filter(pf => !(pf.plan_id === planId && pf.feature_id === featureId));
      } else {
        updatedPlanFeatures = [...prev.planFeatures, {
          plan_id: planId,
          feature_id: featureId
        }];
      }

      return { ...prev,
        planFeatures: updatedPlanFeatures
      };
    });
  };

  const handleToggleAddonFeature = (addonId, featureId) => {
    setAssignments(prev => {
      const mapped = prev.addonFeatures.some(af => af.addon_id === addonId && af.feature_id === featureId);
      let updatedAddonFeatures;

      if (mapped) {
        updatedAddonFeatures = prev.addonFeatures.filter(af => !(af.addon_id === addonId && af.feature_id === featureId));
      } else {
        updatedAddonFeatures = [...prev.addonFeatures, {
          addon_id: addonId,
          feature_id: featureId
        }];
      }

      return { ...prev,
        addonFeatures: updatedAddonFeatures
      };
    });
  };

  const handleSaveAssignments = async () => {
    try {
      const res = await fetch(`${API_BASE}/admin/features/assignments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(assignments)
      }).then(r => r.json());

      if (res.success) {
        showToast('Feature assignments updated successfully!');
        fetchData();
      } else {
        showToast(res.error?.message || 'Error updating feature assignments', false);
      }
    } catch (err) {
      showToast('Connection error updating assignments', false);
    }
  };

  return <AdminLayout>
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <h2>{t("Plans & Features Management")}</h2>
          </Col>
        </Row>

        {success && <Alert color="success">{success}</Alert>}
        {error && <Alert color="danger">{error}</Alert>}

        {
        /* Tab Selection */
      }
        <Nav tabs className="mb-4">
          <NavItem>
            <NavLink className={classnames({
            active: activeTab === 'plans'
          })} onClick={() => toggleTab('plans')} style={{
            cursor: 'pointer'
          }}>{t("Subscription Plans")}</NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({
            active: activeTab === 'addons'
          })} onClick={() => toggleTab('addons')} style={{
            cursor: 'pointer'
          }}>{t("Add-on Services")}</NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({
            active: activeTab === 'features'
          })} onClick={() => toggleTab('features')} style={{
            cursor: 'pointer'
          }}>{t("Features List")}</NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({
            active: activeTab === 'relations'
          })} onClick={() => toggleTab('relations')} style={{
            cursor: 'pointer'
          }}>{t("Feature Mapping matrix")}</NavLink>
          </NavItem>
        </Nav>

        {loading ? <div className="text-center py-5">
            <h4>{t("Loading portal data...")}</h4>
          </div> : <TabContent activeTab={activeTab}>
            
            {
          /* PLANS TAB */
        }
            <TabPane tabId="plans">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>{t("Manage Subscription Levels")}</h4>
                <Button color="success" onClick={() => {
              setPlanForm({
                id: '',
                name: '',
                type: 'Individual',
                monthly_price: 0,
                yearly_price: 0,
                description: '',
                cta_label: 'Get Started',
                highlight_badge: '',
                active: true,
                display_order: plans.length + 1,
                billing_price_id: ''
              });
              setPlanModal(true);
            }}>
                  <FontAwesomeIcon icon={faPlus} className="mr-2" />{t("Add Plan")}</Button>
              </div>

              <Table responsive striped className="align-middle">
                <thead>
                  <tr>
                    <th>{t("Display Order")}</th>
                    <th>{t("Plan Name")}</th>
                    <th>{t("Type")}</th>
                    <th>{t("Monthly Price")}</th>
                    <th>{t("Yearly Price")}</th>
                    <th>{t("Badge")}</th>
                    <th>{t("Stripe Price ID")}</th>
                    <th>{t("Status")}</th>
                    <th>{t("Actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {plans.map(plan => <tr key={plan.id}>
                      <td>{plan.display_order}</td>
                      <td><strong>{plan.name}</strong><br /><small className="text-muted">{plan.description}</small></td>
                      <td>{plan.type}</td>
                      <td>{plan.monthly_price !== null ? `$${plan.monthly_price}` : 'Custom'}</td>
                      <td>{plan.yearly_price !== null ? `$${plan.yearly_price}` : 'Custom'}</td>
                      <td>{plan.highlight_badge || '-'}</td>
                      <td><small className="text-monospace text-muted">{plan.billing_price_id || 'None'}</small></td>
                      <td>
                        {plan.active ? <span className="badge badge-success">{t("Active")}</span> : <span className="badge badge-secondary">{t("Inactive")}</span>}
                      </td>
                      <td>
                        <Button color="primary" size="sm" className="mr-2" onClick={() => {
                    setPlanForm(plan);
                    setPlanModal(true);
                  }}>
                          <FontAwesomeIcon icon={faEdit} />
                        </Button>
                        <Button color="danger" size="sm" onClick={() => handleDeletePlan(plan.id)}>
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </td>
                    </tr>)}
                </tbody>
              </Table>
            </TabPane>

            {
          /* ADDONS TAB */
        }
            <TabPane tabId="addons">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>{t("Manage \xC0 La Carte Services")}</h4>
                <Button color="success" onClick={() => {
              setAddonForm({
                id: '',
                name: '',
                description: '',
                monthly_price: 0,
                price_type: 'flat',
                active: true,
                display_order: addons.length + 1,
                billing_price_id: ''
              });
              setAddonModal(true);
            }}>
                  <FontAwesomeIcon icon={faPlus} className="mr-2" />{t("Add Add-on")}</Button>
              </div>

              <Table responsive striped className="align-middle">
                <thead>
                  <tr>
                    <th>{t("Display Order")}</th>
                    <th>{t("Add-on Name")}</th>
                    <th>{t("Monthly Price")}</th>
                    <th>{t("Price Type")}</th>
                    <th>{t("Stripe Price ID")}</th>
                    <th>{t("Status")}</th>
                    <th>{t("Actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {addons.map(addon => <tr key={addon.id}>
                      <td>{addon.display_order}</td>
                      <td><strong>{addon.name}</strong><br /><small className="text-muted">{addon.description}</small></td>
                      <td>${addon.monthly_price}</td>
                      <td>{addon.price_type}</td>
                      <td><small className="text-monospace text-muted">{addon.billing_price_id || 'None'}</small></td>
                      <td>
                        {addon.active ? <span className="badge badge-success">{t("Active")}</span> : <span className="badge badge-secondary">{t("Inactive")}</span>}
                      </td>
                      <td>
                        <Button color="primary" size="sm" className="mr-2" onClick={() => {
                    setAddonForm(addon);
                    setAddonModal(true);
                  }}>
                          <FontAwesomeIcon icon={faEdit} />
                        </Button>
                        <Button color="danger" size="sm" onClick={() => handleDeleteAddon(addon.id)}>
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </td>
                    </tr>)}
                </tbody>
              </Table>
            </TabPane>

            {
          /* FEATURES TAB */
        }
            <TabPane tabId="features">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>{t("Manage Features Pool")}</h4>
                <Button color="success" onClick={() => {
              setFeatureForm({
                id: '',
                name: '',
                description: '',
                category: 'Branding',
                active: true,
                display_order: features.length + 1
              });
              setFeatureModal(true);
            }}>
                  <FontAwesomeIcon icon={faPlus} className="mr-2" />{t("Add Feature")}</Button>
              </div>

              <Table responsive striped className="align-middle">
                <thead>
                  <tr>
                    <th>{t("Display Order")}</th>
                    <th>{t("Feature Name")}</th>
                    <th>{t("Category")}</th>
                    <th>{t("Status")}</th>
                    <th>{t("Actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {features.map(feat => <tr key={feat.id}>
                      <td>{feat.display_order}</td>
                      <td><strong>{feat.name}</strong><br /><small className="text-muted">{feat.description}</small></td>
                      <td>{feat.category}</td>
                      <td>
                        {feat.active ? <span className="badge badge-success">{t("Active")}</span> : <span className="badge badge-secondary">{t("Inactive")}</span>}
                      </td>
                      <td>
                        <Button color="primary" size="sm" className="mr-2" onClick={() => {
                    setFeatureForm(feat);
                    setFeatureModal(true);
                  }}>
                          <FontAwesomeIcon icon={faEdit} />
                        </Button>
                        <Button color="danger" size="sm" onClick={() => handleDeleteFeature(feat.id)}>
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </td>
                    </tr>)}
                </tbody>
              </Table>
            </TabPane>

            {
          /* RELATIONS MATRIX TAB */
        }
            <TabPane tabId="relations">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>{t("Map Features to Plans & Add-ons")}</h4>
                <Button color="success" onClick={handleSaveAssignments}>{t("Save All Assignments")}</Button>
              </div>

              <Card className="mb-4">
                <CardBody>
                  <h5>{t("Subscription Plans Feature Matrix")}</h5>
                  <div className="table-responsive">
                    <Table bordered striped className="text-center align-middle">
                      <thead>
                        <tr>
                          <th className="text-left">{t("Feature")}</th>
                          {plans.map(p => <th key={p.id} style={{
                        minWidth: 120
                      }}>{p.name}</th>)}
                        </tr>
                      </thead>
                      <tbody>
                        {features.map(f => <tr key={f.id}>
                            <td className="text-left">
                              <strong>{f.name}</strong><br />
                              <small className="text-muted">{f.category}</small>
                            </td>
                            {plans.map(p => {
                        const checked = isFeatureMappedToPlan(p.id, f.id);
                        return <td key={p.id} onClick={() => handleTogglePlanFeature(p.id, f.id)} style={{
                          cursor: 'pointer'
                        }}>
                                  <FontAwesomeIcon icon={checked ? faCheck : faTimes} className={checked ? 'text-success' : 'text-muted'} size="lg" />
                                </td>;
                      })}
                          </tr>)}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <h5>{t("Add-on Services Feature Matrix")}</h5>
                  <div className="table-responsive">
                    <Table bordered striped className="text-center align-middle">
                      <thead>
                        <tr>
                          <th className="text-left">{t("Feature")}</th>
                          {addons.map(a => <th key={a.id} style={{
                        minWidth: 120
                      }}>{a.name}</th>)}
                        </tr>
                      </thead>
                      <tbody>
                        {features.map(f => <tr key={f.id}>
                            <td className="text-left">
                              <strong>{f.name}</strong><br />
                              <small className="text-muted">{f.category}</small>
                            </td>
                            {addons.map(a => {
                        const checked = isFeatureMappedToAddon(a.id, f.id);
                        return <td key={a.id} onClick={() => handleToggleAddonFeature(a.id, f.id)} style={{
                          cursor: 'pointer'
                        }}>
                                  <FontAwesomeIcon icon={checked ? faCheck : faTimes} className={checked ? 'text-success' : 'text-muted'} size="lg" />
                                </td>;
                      })}
                          </tr>)}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </TabPane>

          </TabContent>}
      </Container>

      {
      /* PLAN CRUD MODAL */
    }
      <Modal isOpen={planModal} toggle={() => setPlanModal(false)}>
        <Form onSubmit={handleSavePlan}>
          <ModalHeader toggle={() => setPlanModal(false)}>
            {planForm.id ? 'Edit Plan' : 'Create Subscription Plan'}
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>{t("Plan Name")}</Label>
              <Input required type="text" value={planForm.name} onChange={e => setPlanForm({ ...planForm,
              name: e.target.value
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Plan Type")}</Label>
              <Input type="select" value={planForm.type} onChange={e => setPlanForm({ ...planForm,
              type: e.target.value
            })}>
                <option value="Individual">{t("Individual")}</option>
                <option value="Business">{t("Business")}</option>
                <option value="Custom">{t("Custom")}</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label>{t("Monthly Price ($)")}</Label>
              <Input type="number" step="0.01" value={planForm.monthly_price || 0} onChange={e => setPlanForm({ ...planForm,
              monthly_price: parseFloat(e.target.value)
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Yearly Price ($)")}</Label>
              <Input type="number" step="0.01" value={planForm.yearly_price || 0} onChange={e => setPlanForm({ ...planForm,
              yearly_price: parseFloat(e.target.value)
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Description")}</Label>
              <Input type="textarea" value={planForm.description || ''} onChange={e => setPlanForm({ ...planForm,
              description: e.target.value
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("CTA Label")}</Label>
              <Input type="text" value={planForm.cta_label} onChange={e => setPlanForm({ ...planForm,
              cta_label: e.target.value
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Highlight Badge Text")}</Label>
              <Input type="text" placeholder={t("e.g. Most Popular")} value={planForm.highlight_badge || ''} onChange={e => setPlanForm({ ...planForm,
              highlight_badge: e.target.value
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Display Order")}</Label>
              <Input type="number" value={planForm.display_order} onChange={e => setPlanForm({ ...planForm,
              display_order: parseInt(e.target.value, 10)
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Billing Price ID Placeholder")}</Label>
              <Input type="text" placeholder={t("e.g. price_1...")} value={planForm.billing_price_id || ''} onChange={e => setPlanForm({ ...planForm,
              billing_price_id: e.target.value
            })} />
            </FormGroup>
            <FormGroup check className="mb-2">
              <Label check>
                <Input type="checkbox" checked={planForm.active} onChange={e => setPlanForm({ ...planForm,
                active: e.target.checked
              })} />{' '}{t("Active")}</Label>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setPlanModal(false)}>{t("Cancel")}</Button>
            <Button color="success" type="submit">{t("Save Plan")}</Button>
          </ModalFooter>
        </Form>
      </Modal>

      {
      /* ADDON CRUD MODAL */
    }
      <Modal isOpen={addonModal} toggle={() => setAddonModal(false)}>
        <Form onSubmit={handleSaveAddon}>
          <ModalHeader toggle={() => setAddonModal(false)}>
            {addonForm.id ? 'Edit Add-on' : 'Create Add-on'}
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>{t("Add-on Name")}</Label>
              <Input required type="text" value={addonForm.name} onChange={e => setAddonForm({ ...addonForm,
              name: e.target.value
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Description")}</Label>
              <Input type="textarea" value={addonForm.description || ''} onChange={e => setAddonForm({ ...addonForm,
              description: e.target.value
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Monthly Price ($)")}</Label>
              <Input required type="number" step="0.01" value={addonForm.monthly_price} onChange={e => setAddonForm({ ...addonForm,
              monthly_price: parseFloat(e.target.value)
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Price Type")}</Label>
              <Input type="select" value={addonForm.price_type} onChange={e => setAddonForm({ ...addonForm,
              price_type: e.target.value
            })}>
                <option value="flat">{t("Flat monthly rate")}</option>
                <option value="per user">{t("Per user")}</option>
                <option value="per business">{t("Per business")}</option>
                <option value="per card">{t("Per info card")}</option>
                <option value="per API key">{t("Per API key")}</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label>{t("Display Order")}</Label>
              <Input type="number" value={addonForm.display_order} onChange={e => setAddonForm({ ...addonForm,
              display_order: parseInt(e.target.value, 10)
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Billing Price ID Placeholder")}</Label>
              <Input type="text" placeholder={t("e.g. price_1...")} value={addonForm.billing_price_id || ''} onChange={e => setAddonForm({ ...addonForm,
              billing_price_id: e.target.value
            })} />
            </FormGroup>
            <FormGroup check className="mb-2">
              <Label check>
                <Input type="checkbox" checked={addonForm.active} onChange={e => setAddonForm({ ...addonForm,
                active: e.target.checked
              })} />{' '}{t("Active")}</Label>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setAddonModal(false)}>{t("Cancel")}</Button>
            <Button color="success" type="submit">{t("Save Add-on")}</Button>
          </ModalFooter>
        </Form>
      </Modal>

      {
      /* FEATURE CRUD MODAL */
    }
      <Modal isOpen={featureModal} toggle={() => setFeatureModal(false)}>
        <Form onSubmit={handleSaveFeature}>
          <ModalHeader toggle={() => setFeatureModal(false)}>
            {featureForm.id ? 'Edit Feature' : 'Create Feature Pool Entry'}
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>{t("Feature Name")}</Label>
              <Input required type="text" value={featureForm.name} onChange={e => setFeatureForm({ ...featureForm,
              name: e.target.value
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Description")}</Label>
              <Input type="textarea" value={featureForm.description || ''} onChange={e => setFeatureForm({ ...featureForm,
              description: e.target.value
            })} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Category")}</Label>
              <Input type="select" value={featureForm.category} onChange={e => setFeatureForm({ ...featureForm,
              category: e.target.value
            })}>
                <option value="Usage Limit">{t("Usage Limit")}</option>
                <option value="Branding">{t("Branding")}</option>
                <option value="Security">{t("Security")}</option>
                <option value="Features">{t("Features")}</option>
                <option value="Support">{t("Support")}</option>
                <option value="Developer">{t("Developer")}</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label>{t("Display Order")}</Label>
              <Input type="number" value={featureForm.display_order} onChange={e => setFeatureForm({ ...featureForm,
              display_order: parseInt(e.target.value, 10)
            })} />
            </FormGroup>
            <FormGroup check className="mb-2">
              <Label check>
                <Input type="checkbox" checked={featureForm.active} onChange={e => setFeatureForm({ ...featureForm,
                active: e.target.checked
              })} />{' '}{t("Active")}</Label>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setFeatureModal(false)}>{t("Cancel")}</Button>
            <Button color="success" type="submit">{t("Save Feature")}</Button>
          </ModalFooter>
        </Form>
      </Modal>
    </AdminLayout>;
}